export const LOCAL_STORAGE_PREFIX = 'solid_';

export function setLocalStorageItem(key: string, value: string) {
  window.localStorage.setItem(`${LOCAL_STORAGE_PREFIX}${key}`, value);
}
export function getLocalStorageKey(key: string) {
  return window.localStorage.getItem(`${LOCAL_STORAGE_PREFIX}${key}`);
}
